module.exports = __webpack_public_path__ + "img/Plus.950f01fd.svg";